import { AnswerColumnPropVersion, } from '../types/prism';
export const ANSWER_COLUMN_CLIENT_STATE_LATEST_VERSION = AnswerColumnPropVersion.V1;
export const initAnswerColumnClientState = (vizModel) => ({
    __typename: 'AnswerColumnProps',
    columnProperties: null,
    version: ANSWER_COLUMN_CLIENT_STATE_LATEST_VERSION,
});
//# sourceMappingURL=answer-column-client-state-init.js.map